<template>
  <v-row class="align-center d-flex h-100">
    <v-col lg="4" md="7" class="mx-auto">
      <v-card class="card-shadow border-radius-xl py-1">
        <div
          class="
            card-padding
            text-center
            mt-n7
            bg-gradient-primary
            shadow-primary
            border-radius-lg
            mx-4
          "
        >
          <h4 class="text-h4 text-white font-weight-bold">Manager auswählen</h4>
          <p class="text-white opacity-8 mb-0">
            Wählen Sie die Organisation für Ihre Arbeit aus
          </p>
        </div>

        <div class="card-padding">
          <p class="text-sm text-body mb-4">
            Sie haben Zugriff auf mehrere Manager. Bitte wählen Sie aus, für welchen Manager Sie arbeiten möchten:
          </p>

          <v-list>
            <v-list-item-group
              v-model="selectedManager"
              mandatory
            >
              <v-list-item
                v-for="manager in accessibleManagers"
                :key="manager.id"
                :value="manager.id"
                @click="selectManager(manager.id)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ manager.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    Rolle: {{ getRoleDisplayName(manager.role) }}
                    <span v-if="manager.isOwn" class="text-primary font-weight-bold">(Eigene Events)</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon color="primary">mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>

          <v-btn
            elevation="0"
            :ripple="false"
            height="43"
            class="
              font-weight-bold
              text-uppercase
              btn-default
              bg-gradient-primary
              py-2
              px-6
              me-2
              mt-6
              mb-2
              w-100
            "
            color="white"
            :disabled="!selectedManager"
            @click="confirmSelection"
          >
            Auswahl bestätigen
          </v-btn>

          <div class="text-center mt-4">
            <v-btn
              text
              small
              @click="logout"
            >
              Abmelden
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ManagerSelection',
  data() {
    return {
      selectedManager: null
    }
  },
  computed: {
    ...mapGetters(['accessibleManagers'])
  },
  methods: {
    ...mapActions(['setCurrentForManager']),

    getRoleDisplayName(role) {
      const roleNames = {
        'admin': 'Administrator',
        'manager': 'Manager',
        'pos': 'POS-Nutzer',
        'checker': 'Kontrolleur'
      }
      return roleNames[role] || role
    },

    selectManager(managerId) {
      this.selectedManager = managerId
    },

    async confirmSelection() {
      if (!this.selectedManager) return

      // Manager-Organisation setzen
      await this.setCurrentForManager(this.selectedManager)

      // Zum Dashboard weiterleiten
      this.$router.push('/admin/analytics').catch(() => {})
    },

    logout() {
      // Hier könnte ein Logout implementiert werden
      // Für jetzt einfach zur Login-Seite
      this.$router.push('/admin/login').catch(() => {})
    }
  },

  mounted() {
    // Falls bereits ein Manager ausgewählt ist, weiterleiten
    if (this.$store.getters['AuthStore/currentForManagerId']) {
      this.$router.push('/admin/analytics').catch(() => {})
    }
  }
}
</script>

<style scoped>
.card-shadow {
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05) !important;
}

.border-radius-xl {
  border-radius: 0.75rem !important;
}

.border-radius-lg {
  border-radius: 0.5rem !important;
}
</style>